import { render, staticRenderFns } from "./KlinikTash.vue?vue&type=template&id=32895c7b"
import script from "./KlinikTash.vue?vue&type=script&lang=js"
export * from "./KlinikTash.vue?vue&type=script&lang=js"
import style0 from "./KlinikTash.vue?vue&type=style&index=0&id=32895c7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports